import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AFConsent, AFOUSFinraConsent, AFOtherBgcInfo, AFSubmitResponse, AFDisclosure } from '../model/af.model';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class ConsentService {

  constructor(private readonly userService: AuthService, private readonly http: HttpClient) {
  }

  getConsent(): Observable<AFConsent> {
    return this.http.post<AFConsent>(environment.api_uri + 'getConsent', { 'verifyId': this.userService.getVerifyId() });
  }

  getOtherBgcInfo(): Observable<AFOtherBgcInfo> {
    return this.http.post<AFOtherBgcInfo>(environment.api_uri + 'getOtherBgcInfo', { 'verifyId': this.userService.getVerifyId() });
  }

  saveOtherBgcInfo(afOtherBgcInfo): Observable<AFOtherBgcInfo> {
    const requestUrl = environment.api_uri + 'saveOtherBgcInfo';
    return this.http.post<AFOtherBgcInfo>(requestUrl, afOtherBgcInfo);
  }

  getAFOUSFinraConsent(): Observable<AFOUSFinraConsent> {
    return this.http.post<AFOUSFinraConsent>(environment.api_uri + 'getOusConsent', { 'verifyId': this.userService.getVerifyId() })
      .pipe(
        map(response => {
          if (!response.isFinraTermsConditionsAccepted) {
            response.isFinraTermsConditionsAccepted = null;
          }
          if (!response.isFinraLegalRequirementsMet) {
            response.isFinraLegalRequirementsMet = null;
          }
          return response;
        }
        )
      )
  }

  getAfDisclosure(): Observable<AFDisclosure> {
    return this.http.post<AFDisclosure>(environment.api_uri + 'getDisclosure', { 'verifyId': this.userService.getVerifyId() })
      .pipe(
        map(response => {

          if (response.relatives === '-1') {
            response.relatives = null;
          }
          if (response.investigation === '-1') {
            response.investigation = null;
          }
          if (response.outsideBusinessQuestion1 === '-1') {
            response.outsideBusinessQuestion1 = null;
          }
          if (response.employedCompensated === '-1') {
            response.employedCompensated = null;
          }
          if (response.employeeOfEntity === '-1') {
            response.employeeOfEntity = null;
          }
          if (response.contactWithEntity === '-1') {
            response.contactWithEntity = null;
          }
          if (!response.legalRequirementsMet) {
            response.legalRequirementsMet = null;
          }
          if (!response.discTermsCheck) {
            response.discTermsCheck = null;
          }

          return response;
        }));
  }

  saveAfOUSFinraConsent(afDisclosureInfo): Observable<string> {
    const requestUrl = environment.api_uri + 'saveOusConsent';
    return this.http.post(requestUrl, afDisclosureInfo, { responseType: 'text' });
  }

  saveAfDisclosure(afDisclosureInfo): Observable<AFDisclosure> {
    const requestUrl = environment.api_uri + 'saveDisclosure';
    return this.http.post<AFDisclosure>(requestUrl, afDisclosureInfo);
  }

  removeAttachment(attachmentId: string): Observable<string> {
    const requestUrl = environment.api_uri + 'removeAttachment';
    const fd = new FormData();
    fd.append("attachmentId", attachmentId);
    return this.http.post<string>(requestUrl, fd);
  }

  saveApplicantForm(consentHistory): Observable<AFSubmitResponse> {
    const requestUrl = environment.api_uri + 'saveApplicant';
    return this.http.post<AFSubmitResponse>(requestUrl, consentHistory);
  }
}